import { RouteConfig } from "vue-router";
import { requireAuthAndLocation } from "../../auth";

const ProposalsTemplateBuilder = () =>
    import('@/pmd/pages/payments/ProposalsTemplateBuilder.vue')

export const DocumentsContractsTemplateBuilderRoute: RouteConfig[] = [
    {
        path: 'payments/proposals-estimates/templates/edit/:id',
        name: 'proposals-estimates-template-builder',
        component: ProposalsTemplateBuilder,
        beforeEnter: requireAuthAndLocation,
        children: [],
        meta: {
            hideSideBar: true,
            hideTopBar: true,
        },
    },
]
